import React from 'react';
import connectToStores from 'alt/utils/connectToStores';

import ShiftPaymentForm from '../forms/ShiftPaymentForm'

import PaymentStore from '../stores/PaymentStore';
import ShiftStore from '../stores/ShiftStore';

@connectToStores
class EditShiftSettings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: 1,
            formData: {}
        };

        PaymentStore.getPayments()
    }

    static getPropsFromStores() {
        return {
            paymentStore: PaymentStore.getState(),
            shiftStore: ShiftStore.getState()
        };
    }

    static getStores() {
        return [PaymentStore, ShiftStore];
    }

    componentDidMount() {
        const shift = this.props.shift;
        this.props.onChange(this.prepareSettingsData(shift), this.refs.form.validate(true).errors, 3);
    }

    prepareSettingsData(shift) {
        let curShift = {};
        if (shift.payment_method_id) {
            curShift.payment = shift.payment_method_id.toString();
        }
        curShift.paymentDescription = shift.payment_delivery_info == null ? '' : shift.payment_delivery_info;
        curShift.chat = shift.chat;
        return curShift;
    }

    onChange(value) {
        const errors = this.refs.form.validate(true).errors;
        this.props.onChange(value, errors, 3, true);
    }

    render () {
        const shift = this.props.shift || {};

        return (
            <div className={"edit-shift-settings" + (this.props.isActive ? " active" : "")}>
                <div className="finish-form-content">
                    <form noValidate>
                        <ShiftPaymentForm
                            disabled = {this.props.disabled}
                            initialFormData={this.prepareSettingsData(shift)}
                            errors={this.props.shiftStore.createError}
                            ref="form"
                            onChange={this.onChange.bind(this)}
                            payments={this.props.paymentStore.payments} />
                    </form>
                </div>
            </div>
        );
    }
}

export default EditShiftSettings;



/** WEBPACK FOOTER **
 ** ./app/src/components/EditShiftSettings.js
 **/